<template>
  <div class="flex flex-col px-4">
    <div class="text-[14px] text-white mt-6 mb-4">{{ $t('SaquePw.LoginPw') }}</div>
    <div
      class="flex items-center bg-[#2C7952]/30 rounded-lg focus-within:bg-[#2C7952]/70 relative"
    >
      <input
        placeholder="Inserir senha"
        v-model="inputValue"
        class="text-white flex-1 h-[44px] bg-[#2C7952]/40 border-none outline-none pl-2 placeholder:text-white/50 placeholder:text-[14px]"
        :type="isLook ? 'text' : 'password'"
      />

      <img
        :src="isLook ? look : look_off"
        class="w-6 h-6 mx-2 absolute right-2"
        @click="handleLook"
      />
    </div>
    <van-button
      @click="handleNext"
      :class="[
        '!mt-4',
        inputValue.length === 0 ? 'primaryBtn_transparent' : 'primaryBtn',
      ]"
      :disabled="inputValue.length === 0"
      >{{ $t('Common.Confirm') }}</van-button
    >
  </div>
</template>

<script setup lang="ts">
import look from "./../images/look.png";
import look_off from "./../images/look_off.png";
import { checkWithdrawalLoginPassword } from "@/api/saque";
import { encryptPassword } from "@/utils";
const emit = defineEmits(["next", "setLoginPassword"]);
const inputValue = ref<string>("");
const isLook = ref<boolean>(false);
const handleLook = () => {
  isLook.value = !isLook.value;
};

const handleNext = async () => {
  const res = await checkWithdrawalLoginPassword({
    value: encryptPassword(inputValue.value),
  });
  if (res.code === 1) {
    emit("setLoginPassword", encryptPassword(inputValue.value));
    emit("next");
  }
};
</script>

<style lang="scss" scoped></style>
